var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allData)?_c('div',{staticClass:"OrgStructure"},[_c('OrgStructureHeader',{attrs:{"title":"Организационная структура"}}),_c('OrgStructureTable',{attrs:{"data":_vm.allData}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }